export const clearCorruptedAuthState = (): void => {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key?.startsWith('CognitoIdentityServiceProvider.')) {
        localStorage.removeItem(key)
      }
    }

    const oauthKeysToRemove = [
      'amplify-signin-with-hostedUI',
      'amplify-oauth-state',
      'amplify-oauth-pkce',
      'amplify-auto-track-session',
      'amplify-redirected-from-hosted-ui',
    ]

    for (const key of oauthKeysToRemove) {
      localStorage.removeItem(key)
      sessionStorage.removeItem(key)
    }
  } catch (storageError) {
    console.error('Error clearing corrupted auth state:', storageError)
  }
}
